/**
 * Chuỗi cho Strategy Tester (domain tách riêng, 2026-10-22).
 *
 * Vì sao tách file: `ui.strategy.*` nằm chung trong `messages.en.ts` / `messages.vi.ts` —
 * hai file **đóng băng** ở đúng size hiện tại (`config/fat-file-budget.json`), nên mọi
 * chuỗi mới đều phải bump ngân sách. Tách domain theo đúng convention repo (dock,
 * trading, settings, pricePane, a11y) vừa giải tải file đóng băng vừa đẩy W1
 * ("tách file i18n theo domain") đi được một bước.
 *
 * 13 chuỗi **tiếng Anh hard-code** của panel cũng được gom vào đây: panel là bề mặt
 * **Pro** mà người dùng tiếng Việt thấy ⇒ Rule 1 (không hard-code UI text).
 */
export const strategyMessagesEn = {
    // --- Nhãn báo cáo (chuyển từ messages.en.ts) ---
    "ui.strategy.report": "Strategy Backtest",
    "ui.strategy.netProfit": "Net Profit",
    "ui.strategy.winRate": "Win Rate",
    "ui.strategy.profitFactor": "Profit Factor",
    "ui.strategy.totalTrades": "Total Trades",
    "ui.strategy.saveRun": "Save run",
    "ui.strategy.runSaved": "Run saved",
    // --- Chọn chiến lược ---
    "ui.strategy.source.pine": "My Pine strategy",
    "ui.strategy.preset.ema": "EMA Crossover (EMA 20/Price)",
    "ui.strategy.preset.rsi": "RSI Reversal (30/70)",
    "ui.strategy.preset.sma_cross": "SMA Crossover (10/50)",
    "ui.strategy.preset.bb": "Bollinger Bands Touch",
    "ui.strategy.run": "Run Backtest",
    "ui.strategy.runPine": "Run my Pine strategy",
    "ui.strategy.hint": "Select a strategy and click \"Run Backtest\" to generate a report.",
    "ui.strategy.noTrades": "No trades generated by strategy.",
    "ui.strategy.pineNeedsBars": "A Pine strategy needs price data. Open a chart with data first.",
    "ui.strategy.pineError": "Strategy error: {{message}}",
    "ui.strategy.pineNotStrategy": "The active Pine script is not a strategy (no strategy(...) declaration).",
    "ui.pinescript.proModuleNotLoaded": "PineScript Pro module is not loaded. Install @vninvestcharts/widget-pro to enable the Pine editor and backtests.",
    "ui.strategy.maxDrawdown": "Max drawdown",
    "ui.strategy.profitFactorHint": "Total gross profit divided by total gross loss. Above 1.0 means the strategy earns more than it loses.",
    "ui.strategy.maxDrawdownHint": "Largest peak-to-trough decline of the equity curve. Lower is safer.",
    "ui.strategy.equity": "Equity curve",
    "ui.strategy.compareSaved": "Compare with saved",
    "ui.strategy.openAsPine": "Open as Pine",
    // --- Bảng giao dịch ---
    "ui.strategy.trade.type": "Type",
    "ui.strategy.trade.entryPrice": "Entry Price",
    "ui.strategy.trade.exitPrice": "Exit Price",
    "ui.strategy.trade.pnl": "PnL",
    "ui.strategy.trade.pnlPercent": "PnL %",
    "ui.strategy.trade.date": "Date",
    "ui.strategy.trade.long": "Long",
    "ui.strategy.trade.short": "Short",
    "ui.strategy.gridTierRequired": "tier Pro required for grid search",
    "ui.strategy.gridBarsTooLarge": "bars > 5000: grid search disabled",
    "ui.strategy.gridCrossSymbolUnsupported": "grid search does not support cross-symbol",
    "ui.strategy.grid.hideGrid": "Hide grid",
    "ui.strategy.grid.gridSearch": "Grid search",
    "ui.strategy.grid.running": "Running…",
    "ui.strategy.grid.runGrid": "Run grid",
    "ui.strategy.grid.cancel": "Cancel",
    "ui.strategy.grid.applyBest": "Apply best",
    "ui.strategy.grid.exportCsv": "Export CSV",
};
